/**
 * urlar: Video section - autoplay when video comes into view.
 * Uses Intersection Observer: play when in view, pause when out.
 * For iframes (YouTube/Vimeo): set src when in view (loads with autoplay in URL).
 */
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-video-autoplay-view]');
  if (!containers.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const container = entry.target;
        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe[data-src]');

        if (video) {
          if (entry.isIntersecting) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        } else if (iframe && entry.isIntersecting) {
          const src = iframe.getAttribute('data-src');
          if (src) {
            iframe.setAttribute('src', src);
            iframe.removeAttribute('data-src');
          }
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.25 }
  );

  containers.forEach((container) => observer.observe(container));
});
